<template>
  <div class="measureSet-view">
    <div id="measureSet-view-header">
      <SidebarToggleView />
      <span class="display-2" v-if="measureSet"
        >TOM<span class="display-2" v-if="measureSet.seq_nr"> Nr. {{ measureSet.seq_nr }}</span></span
      >
      <span style="float:right">
        <v-btn text icon v-on:click="nextMeasureSet()">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </span>
      <span style="float:right">
        <v-btn text icon v-on:click="prevMeasureSet()">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </span>
    </div>
    <div id="measureSet-view-content">
      <div v-if="loading">Lade...</div>
      <div v-else-if="errors.length > 0">Fehler beim Laden</div>
      <div v-else-if="measureSet">
        <span v-if="measureSet.updatedAt"
          >Letzte Änderung am {{ measureSet.updatedAt | moment("DD.MM.YYYY") }} um
          {{ measureSet.updatedAt | moment("HH.mm") }} Uhr</span
        >
        <v-container container--fluid>
          <v-subheader>Status</v-subheader>
          <v-row align="center">
            <v-col cols="4">
              <v-card class="d-flex align-center" outlined height="72">
                <div>
                  <span>
                    <v-icon
                      class="ml-2 mr-1"
                      style="float:left"
                      :color="
                        measureSet.status == 'SPECIFIED' || measureSet.status == 'COMPLETED' ? 'info' : 'grey lighten-2'
                      "
                      >brightness_1</v-icon
                    >
                    <v-icon
                      class="mr-2"
                      style="float:left"
                      :color="measureSet.status == 'COMPLETED' ? 'info' : 'grey lighten-2'"
                      >brightness_1</v-icon
                    >
                  </span>
                  <span class="justify-center" style="float:left" v-if="measureSet.status == 'OPEN'">offen</span>
                  <span class="justify-center" style="float:left" v-if="measureSet.status == 'SPECIFIED'"
                    >Maßnahme spezifiziert</span
                  >
                  <span class="justify-center" style="float:left" v-if="measureSet.status == 'COMPLETED'"
                    >Maßnahme erledigt</span
                  >
                </div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="d-flex align-center" outlined>
                <v-checkbox
                  class="ml-2"
                  v-model="statusSpecified"
                  color="info"
                  v-on:change="toggleStatusSpecified"
                  label="Maßnahme spezifiziert"
                ></v-checkbox>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="d-flex align-center" outlined>
                <v-checkbox
                  class="ml-2"
                  v-model="statusCompleted"
                  color="info"
                  v-on:change="toggleStatusCompleted"
                  label="Maßnahme erledigt"
                ></v-checkbox>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <soda-select
          :someModel="measureSet.type"
          :config="measureSet_specs_dic.type"
          :levels="mset_type_labels"
          @input="(someModel) => (measureSet.type = someModel)"
          v-on:change="did_change = true"
        >
        </soda-select>
        <soda-text-area
          :someModel="measureSet.description"
          @input="(someModel) => (measureSet.description = someModel)"
          auto-grow
          rows="1"
          v-on:input="did_change = true"
          :config="measureSet_specs_dic.description"
        >
        </soda-text-area>
        <MSetMeasureListView
          :companyId="company_id"
          :measureSetId="$route.params.msid"
          :measures="measures"
          v-on:measureCreated="onMeasureCreated"
          v-on:measureUpdated="onMeasureUpdated"
          v-on:measureDeleted="onMeasureDeleted"
        />
        <soda-text-area
          :someModel="measureSet.commentatory"
          @input="(someModel) => (measureSet.commentatory = someModel)"
          auto-grow
          rows="1"
          v-on:input="did_change = true"
          :config="measureSet_specs_dic.commentatory"
        >
        </soda-text-area>
        <div class="title">Verknüpfte Verfahren</div>
        <template>
          <v-container fluid v-if="processes.length > 0">
            <v-card outlined height="60" v-for="(item, index) in processes" :key="item.id">
              <v-row no-gutters align="center" class="mt-4">
                <v-col cols="1">
                  <v-row justify="center">
                    <template v-if="item.status === 'OPEN'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-hover>
                            <v-icon
                              v-on="on"
                              slot-scope="{ hover }"
                              v-on:click="toggleProcessMeasureSetStatus(item, index)"
                              :color="`${hover ? 'primary' : 'gray'}`"
                              >check_circle_outline
                            </v-icon>
                          </v-hover>
                        </template>
                        <span>Maßnahme (im Bezug zu diesem Verfahren) als erledigt markieren</span>
                      </v-tooltip>
                    </template>
                    <template v-if="item.status === 'COMPLETED'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-hover>
                            <v-icon
                              v-on="on"
                              slot-scope="{ hover }"
                              v-on:click="toggleProcessMeasureSetStatus(item, index)"
                              :color="`${hover ? 'gray' : 'primary'}`"
                              >check_circle
                            </v-icon>
                          </v-hover>
                        </template>
                        <span>Maßnahme (im Bezug zu diesem Verfahren) als nicht erledigt markieren</span>
                      </v-tooltip>
                    </template>
                  </v-row>
                </v-col>
                <v-col cols="10"> Nr. {{ item.process.seq_nr }} - {{ item.process.text_header }} </v-col>
                <v-col cols="1">
                  <v-row align="center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-hover>
                          <v-icon
                            v-on="on"
                            slot-scope="{ hover }"
                            v-on:click="openProcess(item.process)"
                            :color="`${hover ? 'primary' : 'gray'}`"
                            >open_in_new
                          </v-icon>
                        </v-hover>
                      </template>
                      <span>Verfahren anzeigen</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
          <v-card v-else outlined class="ma-2">
            <v-card-text>
              Mit dieser allgemeinen TOM sind noch keine Verfahren verknüpft. Eine Verknüpfung können Sie bei den
              entsprechenden Verfahren erstellen. Die Verknüpfung erscheint dann hier.
            </v-card-text>
          </v-card>
        </template>
        <div class="mt-12">
          <v-card flat dark class="mt-2">
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Diese allgemeine TOM löschen
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Diese allgemeine TOM dauerhaft und unwiderbringlich löschen
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn outlined color="error" v-on:click="onShowDeleteMeasureSetDialog()">
                    Löschen
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
          <MeasureDeleteView
            :mset_id="measureSet.id"
            :showThis="show_delete_measure_set_dialog"
            v-on:discard="show_delete_measure_set_dialog = false"
            v-on:didDelete="onDeleted()"
          >
          </MeasureDeleteView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { updateMeasureSet } from "../graphql/mutations";
import { updateProcessMeasureSet } from "../graphql/mutations";
import SodaSelect from "./lib/inputs/SodaSelect";
import SodaTextField from "./lib/inputs/SodaTextField";
import SodaTextArea from "./lib/inputs/SodaTextArea";

import MeasureDeleteView from "./MeasureDeleteView";
import SidebarToggleView from "./SidebarToggleView";
import MSetMeasureListView from "./MSetMeasureListView";

import load_specs from "../specs/specs_parser";
const measureSet_specs = load_specs("measureSet.yml");

const getMeasureSet = `query GetMeasureSet($id: ID!) {
  getMeasureSet(id: $id) {
    id
    seq_nr
    type
    description
    processes {
        items {
            id
            status
            process {
              id
              seq_nr
              text_header
            }
        }
      nextToken
    }
    measures (limit: 100) {
      items {
        id
        label
        description
        status
        createdAt
        updatedAt
      }
      nextToken
    }
    commentatory
    status
    createdAt
    updatedAt
  }
}
`;

const getMeasureSets = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    measureSets(limit:50) {
      items {
          id
          seq_nr
          type
      }
    }
  }
}
`;

var mset_old;

export default {
  components: {
    SodaSelect,
    SodaTextField,
    SodaTextArea,
    MeasureDeleteView,
    SidebarToggleView,
    MSetMeasureListView,
  },
  name: "MeasureView",
  computed: {
    did_change: {
      get() {
        return this.$data._did_change;
      },
      set(value) {
        if (value === true) {
          clearTimeout(this.$data._save_timer);
          this.$eventHub.emit("sync-status-touched");
          this.$data._save_timer = setTimeout(() => this.save(), 1000);
        }
        this.$data._did_change = value;
      },
    },
    measureSet_for_save() {
      var mset = { ...this.measureSet };
      mset.description = mset.description !== "" ? mset.description : null;
      mset.commentatory = mset.commentatory !== "" ? mset.commentatory : null;
      mset.updatedAt = undefined; // will be set by aws appsync
      mset.createdAt = undefined; // will be set by aws appsync
      return mset;
    },
    getMeasureSetQuery() {
      return this.$Amplify.graphqlOperation(getMeasureSet, { id: this.measureSet.id });
    },
    updateMeasureSetMutation() {
      return this.$Amplify.graphqlOperation(updateMeasureSet, { input: this.measureSet_for_save });
    },
    updateProcessMeasureSetMutation() {
      return this.$Amplify.graphqlOperation(updateProcessMeasureSet, { input: this.processMeasureSet });
    },
    max_seq_nr: {
      get() {
        return this.$store.state.originalStore.measureSet_max_seq_nr;
      },
      set(value) {
        this.$store.commit("SET_measureSet_max_seq_nr", value);
      },
    },
    company_id() {
      return this.$route.params.cid;
    },
  },
  mounted() {
    // check if route has been provided with an id
    // if yes fetch from api
    // if no just display with placeholders
    this.measureSet_specs = measureSet_specs;
    this.initView(this.company_id, this.$route.params.msid);
    //this.initNewMeasure(this.$route.params.msid)
  },
  async beforeRouteUpdate(to, from, next) {
    if (this.did_change) {
      clearTimeout(this._save_timer);
      await this.save();
    }
    this.initView(to.params.cid, to.params.msid);
    this.initNewMeasure(to.params.msid);
    next();
  },
  methods: {
    initView(cid, msid) {
      this.statusSpecified = false;
      this.statusCompleted = false;
      this.measureSet = { id: msid };
      this.load();
    },
    load() {
      this.loading = true;
      this.$Amplify.API.graphql(this.getMeasureSetQuery)
        .then((response) => this.onLoaded(response))
        .then(this.fetchMsets);
    },
    fetchMsets() {
      this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(getMeasureSets, { id: this.company_id })).then(
        (response) => {
          var measureSets = response.data.getCompany.measureSets.items;
          measureSets.sort((a, b) => (a.seq_nr > b.seq_nr ? 1 : -1));
          this.measureSets_sort_order = measureSets.map((e) => e.id);
          var otherMeasureSetTypes = measureSets.filter((t) => t.type !== this.measureSet.type);
          this.mset_type_labels = this.measureSet_specs_dic.type.levels.map((t) => {
            return {
              text: t,
              value: t,
              disabled: otherMeasureSetTypes.includes(t),
            };
          });
        }
      );
    },
    onLoaded(response) {
      this.measureSet = response.data.getMeasureSet;
      this.measureSet.measureSetCompanyId = this.$route.cid;
      // extract the processes
      this.processes = this.measureSet.processes.items;
      // sort them by seq_nr
      this.processes = this.processes.sort((a, b) => {
        return a.process.seq_nr - b.process.seq_nr;
      });

      this.measureSet.processes = undefined;
      this.measures = this.measureSet.measures.items || [];
      this.measures.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
      this.measureSet.measures = undefined;
      this.measureSet.status = this.measureSet.status || "OPEN";
      this.measureSet.description = this.measureSet.description || "";
      this.measureSet.commentatory = this.measureSet.commentatory || "";

      this.loading = false;
      if (this.measureSet.status == "SPECIFIED") {
        this.statusSpecified = true;
      }
      if (this.measureSet.status == "COMPLETED") {
        this.statusSpecified = true;
        this.statusCompleted = true;
      }

      mset_old = this.measureSet_for_save;
    },
    initNewMeasure(msid) {
      this.newMeasure = {
        label: "",
        status: "OPEN",
        measureSetMeasureMeasureSetId: msid,
      };
    },
    async save() {
      this.$eventHub.emit("sync-status-syncing");
      return new Promise((resolve, reject) => {
        this.$Amplify.API.graphql(this.updateMeasureSetMutation)
          .then((response) => {
            this.onSaved(response);
            resolve();
          })
          .catch((err) => {
            this.$eventHub.emit("sync-status-failure", {
              entity_type: "Allgemeine TOM",
              entity_label: this.measureSet.type,
              sync_type: "update",
              error: err.errors[0].message,
            });
            reject(err);
          });
      });
    },
    onSaved(response) {
      this.measureSet.updatedAt = response.data.updateMeasureSet.updatedAt;
      let mset_new = this.measureSet_for_save;
      this.$recordUpdate(this.company_id, "MEASURESET", mset_old, mset_new, (res, err) => {
        res ? console.log("logged MEASURESET update", res) : console.error("error logging MEASURESET update", err, e);
      });
      mset_old = mset_new;
      this.$eventHub.emit("sync-status-success", {
        entity_type: "Allgemeine TOM",
        entity_label: this.measureSet.type,
        sync_type: "update",
      });
      this.did_change = false;
    },
    onMeasureUpdated(resp, index) {
      //console.log('onMeasureUpdated', resp)
    },
    onMeasureDeleted(index) {
      this.measures.splice(index, 1);
    },
    onMeasureCreated(measure) {
      this.measures.push(measure);
    },
    cancel() {
      this.$router.go(-1);
    },
    nextMeasureSet() {
      var len = this.measureSets_sort_order.length;
      var nextIdIndex = (this.measureSets_sort_order.indexOf(this.measureSet.id) + 1) % len;
      var nextId = this.measureSets_sort_order[nextIdIndex];
      this.$router.push({ path: `/app/company/${this.company_id}/measure/${nextId}` });
    },
    prevMeasureSet() {
      var len = this.measureSets_sort_order.length;
      var prevIdIndex = (this.measureSets_sort_order.indexOf(this.measureSet.id) - 1 + len) % len;
      var prevId = this.measureSets_sort_order[prevIdIndex];
      this.$router.push({ path: `/app/company/${this.company_id}/measure/${prevId}` });
    },
    calculatedStatus() {
      [""];
    },
    toggleStatusSpecified() {
      if (this.measureSet.status == "COMPLETED") {
        this.toggleStatusCompleted();
      }
      if (this.measureSet.status == "SPECIFIED") {
        this.measureSet.status = "OPEN";
        this.statusSpecified = false;
        this.did_change = true;
      } else {
        this.measureSet.status = "SPECIFIED";
        this.statusSpecified = true;
        this.did_change = true;
      }
    },
    toggleStatusCompleted() {
      if (this.measureSet.status == "COMPLETED") {
        this.measureSet.status = "SPECIFIED";
        this.statusCompleted = false;
        this.did_change = true;
      } else {
        this.measureSet.status = "COMPLETED";
        this.statusCompleted = true;
        this.statusSpecified = true;
        this.did_change = true;
      }
    },
    toggleProcessMeasureSetStatus(item, index) {
      this.oldProcessMeasureSet = Object.assign({}, item);
      this.oldProcessMeasureSet.process = undefined;
      if (item.status == "COMPLETED") {
        item.status = "OPEN";
      } else {
        item.status = "COMPLETED";
      }
      this.updateProcessMeasureSet(item, index);
    },
    updateProcessMeasureSet(processMeasureSet, index) {
      this.processMeasureSet = Object.assign({}, processMeasureSet);
      this.processMeasureSet.process = undefined;
      this.$Amplify.API.graphql(this.updateProcessMeasureSetMutation).then((response) =>
        this.onProcessMeasureSetUpdated(response, index)
      );
    },
    onProcessMeasureSetUpdated(resp, index) {
      this.$recordUpdate(
        this.company_id,
        "PROCESSMEASURESET",
        this.oldProcessMeasureSet,
        this.processMeasureSet,
        (res, err) => {
          res
            ? console.log("logged PROCESSMEASURESET update", res)
            : console.error("error logging PROCESSMEASURESET update", err, e);
        }
      );
      this.oldProcessMeasureSet = null;
      this.processMeasureSet = null;
    },
    openProcess(process) {
      this.$router.push(`/app/company/${this.company_id}/process/${process.id}`);
    },
    onShowDeleteMeasureSetDialog() {
      this.show_delete_measure_set_dialog = true;
    },
    onDeleted() {
      this.$router.push({ path: `/app/company/${this.company_id}/measures` });
    },
  },
  data: () => ({
    measureSet: null,
    processMeasureSet: null,
    oldProcessMeasureSet: null,
    measures: [],
    newMeasure: null,
    currentMeasure: null,
    measureSet_specs: null,
    loading: true,
    errors: [],
    _did_change: false,
    measureSet_specs_dic: Object.assign({}, ...measureSet_specs.fields.map((s) => ({ [s.name]: s }))),
    statusSpecified: false,
    statusCompleted: false,
    processes: [],
    _save_timer: null,
    mset_type_labels: null,
    measureSets_sort_order: [],
    show_delete_measure_set_dialog: false,
  }),
};
</script>

<style lang="scss" scoped></style>
